
import _ from 'underscore'
import Backbone from 'backbone'
import HitAreaCollection from '../collections/HitAreaCollection'

class HitAreaSelection {

  constructor(collection) {
    if (_.isArray(collection)) {
      collection = new HitAreaCollection(collection)
    }
    
    this.length = collection.length

    this.where = function (tags = {}) {
      let _tags = {}
      _.each(tags, (value, key) => _tags['tag' + key] = value)
      return new HitAreaSelection(collection.findWhere(_tags))
    }

    this.find = function (id) {
      if (_.isArray(id)) {
        // If a list of id's is provided, ensure all ids are string values.

        id = _.map(id, value => value.toString())

        let result = collection.filter(unit => _.contains(id, unit.id))
        return new HitAreaSelection(result)
      } else {
        let model = collection.get(id.toString())
        return model
          ? new HitAreaSelection([model])
          : new HitAreaSelection([])
      }
    }

    this.first = function () {
      return this.at(0)
    }

    this.at = function (index) {
      return index >= 0 && index < collection.length
        ? new HitAreaSelection([collection.at(index)])
        : new HitAreaSelection([])
    }

    this.color = function (color) {
      collection.color(color)
      return this
    }

    this.stroke = function (color, width = 1) {
      collection.stroke(color, width)
      return this
    }

    this.data = function () {
      return collection.data()
    }
  }
}

export default HitAreaSelection
